'use client';

import {type FC, useState} from 'react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

import {PreviewContextProvider} from '@/components/preview-bar/provider';

import {HeroProvider} from '../page-head/context/page-head-context';

interface Props {
	children: React.ReactNode;
}

export const AppProvider: FC<Props> = ({children}) => {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						// With SSR, we usually want to set some default staleTime
						// above 0 to avoid refetching immediately on the client
						staleTime: 60 * 1000,
					},
				},
			}),
	);

	return (
		<QueryClientProvider client={queryClient}>
			<PreviewContextProvider>
				<HeroProvider>{children}</HeroProvider>
			</PreviewContextProvider>
		</QueryClientProvider>
	);
};
